import { useContext } from 'preact/hooks';
import styleSheet from '../styles/teamSelector.module.scss';
import { TeamSelectorContext } from '../teamSelector.component';

import { getImageUrl } from '../../helpers/images';

const styles = styleSheet.locals || {};

/**
 * Component for showing a SelectorSponsor
 *
 * @returns {Element} <SelectorSponsor />
 */
function SelectorSponsor() {
    const { selector } = useContext(TeamSelectorContext);

    const hasSponsorImg =
        selector.sponsor_image_url || selector.sponsor_external_image_url;

    if (!hasSponsorImg) {
        return null;
    }

    const sponsorUrl = selector?.sponsor_url;

    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
            /* eslint-disable-next-line id-length */
        } catch (_) {
            return false;
        }
    };

    const SPONSOR_IMAGE_WIDTH = 160;
    const validUrl = isValidUrl(sponsorUrl);

    const renderSponsorImage = () => {
        if (selector.sponsor_image_url) {
            return (
                <img
                    src={getImageUrl(
                        selector.sponsor_image_url,
                        SPONSOR_IMAGE_WIDTH
                    )}
                    alt={selector.sponsor_image_text || ''}
                    className={styles.teamSelectorSponsorImage}
                    part="ts-sponsor-image"
                    data-testid="sponsor-image-manual"
                />
            );
        }

        if (selector.sponsor_external_image_url) {
            return (
                <img
                    src={selector.sponsor_external_image_url}
                    alt={selector.sponsor_image_text || ''}
                    className={styles.teamSelectorSponsorImage}
                    part="ts-sponsor-image"
                    data-testid="sponsor-image-automated"
                />
            );
        }

        return null;
    };

    return (
        <div
            data-cy="sponsorLabel"
            className={styles.teamSelectorSponsor}
            data-testid="sponsor"
        >
            {selector.sponsor_label ? (
                <div className={styles.teamSelectorSponsorLabel}>
                    {selector.sponsor_label}
                </div>
            ) : (
                ''
            )}

            {validUrl ? (
                <a href={sponsorUrl} target="_blank" rel="noopener noreferrer">
                    {renderSponsorImage()}
                </a>
            ) : (
                renderSponsorImage()
            )}
        </div>
    );
}

export default SelectorSponsor;
